/**
 * {RelivConferenceDscMenu}
 * @param window
 * @param jQuery
 * @param angular
 * @param $location
 * @param $compile

 * @constructor
 */
var RelivConferenceDscMenu = function (
    window,
    jQuery,
    angular,
    $location,
    $compile
) {
    var self = this;

    self.display = false;

    self.content = '<reliv-conference-dsc-menu-directive></reliv-conference-dsc-menu-directive>';

    self.element = null;

    self.setDisplay = function (show) {

        self.display = show;

        window.localStorage.setItem('relivConferenceDscMenuShow', String(Number(show)));
    };

    self.getDisplay = function () {
        var show = window.localStorage.getItem('relivConferenceDscMenuShow');
        show = Boolean(Number(show));
        return show;
    };

    self.displayToggle = function () {
        var show = self.getDisplay();
        show = !show;
        self.setDisplay(show);
    };

    self.inject = function () {
        self.element = jQuery(self.content);
        self.element.prependTo('body');

        var contents = self.element.contents();
        var aemlement = angular.element(self.element);
        var scope = aemlement.scope;

        $compile(contents)(scope);
    };

    var setDisplayByUrlPath = function () {
        var path = window.location.pathname;
        if (path == '/conf') {
            self.setDisplay(true);
        }
    };

    /**
     *
     */
    var init = function () {
        setDisplayByUrlPath();
        self.display = self.getDisplay();
    };

    init();
};

/**
 * @returns {relivConferenceDscMenu}
 */
angular.module('relivConference').service(
    'relivConferenceDscMenu',
    [
        '$window',
        '$location',
        '$compile',
        function (
            $window,
            $location,
            $compile
        ) {
            return new RelivConferenceDscMenu(
                $window,
                jQuery,
                angular,
                $location,
                $compile
            );
        },
    ]
);
